import Swal from "sweetalert2";
import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";
import React, { useState, useContext, useEffect } from "react";
const ReactQuill =
  typeof window === "object" ? require("react-quill") : () => false;
export default () => {
  const { authState, authDispatch } = useContext(GlobalContext);
  henceforthApi.setToken(authState.access_token);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    created_at: "",
    image_url: "",
    type: "",
    title: "",
    updated_at: "",
    _id: "",
  });
  const [description, setDesciption] = useState("");
  // const handleUpload = async (file) => {
  //   setLoading(true);
  //   const url = `${henceforthApi.API_ROOT}Upload`;
  //   const formData = new FormData();
  //   formData.append("file", file);

  //   const config = {
  //     headers: {
  //       "content-type": "multipart/form-data",
  //       token: authState.access_token,
  //     },
  //   };
  //   const apiRes = await (await axios.post(url, formData, config)).data;
  //   setFileName(apiRes.data.file_name);
  //   setState({
  //     ...state,
  //     image_url: apiRes.data.file_name,
  //   });
  //   const data = {
  //     type: state.type,
  //     image_url: apiRes.data.file_name,
  //     description: description,
  //     title: state.title,
  //     language: "ENGLISH",
  //   };
  //   henceforthApi.Policies.addEditPolicy(data)
  //     .then((res) => {
  //       setLoading(false);
  //       initialiseData();
  //       console.log(res);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       setLoading(false);
  //     });
  // };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      type: state.type,
      title: state.title,
      // image_url: state.image_url,
      description: description,
      language: "ENGLISH",
    };
    if (state.image_url) {
      data["image_url"] = state.image_url;
    }

    henceforthApi.Policies.addEditPolicy(data)
      .then((res) => {
        setLoading(false);
        // console.log(res);
        Swal.fire({
          title: "content updated",
          text: "content updated successfully",
          icon: "success",
          confirmButtonText: "OK",
          confirmButtonColor: "black"
        });
        window.history.back();
      })
      .catch((err) => {
        // console.log(err);
        setLoading(false);
        Swal.fire({
          title: "Error!",
          text:
            typeof err.response.body.error_description == "string"
              ? err.response.body.error_description
              : JSON.stringify(err.response.body.error_description),
          icon: "error",
          confirmButtonText: "Cancel",
          confirmButtonColor: "black"
        });
      });
  };
  const initialiseData = async () => {
    try {
      let apiRes = await henceforthApi.Policies.byType(state.type);
      let obj =
        Array.isArray(apiRes.data.data) && apiRes.data.data.length
          ? apiRes.data.data[0]
          : apiRes.data.data;
      setState({
        ...state,
        ...obj,
      });
      setDesciption(obj.description);
    } catch (error) { }
  };
  useEffect(() => {
    initialiseData();
  }, []);

  const onEditorStateChange = (e) => {
    // console.log(e);
    setDesciption(e);
  };
  return (
    <div className="animated fadeInRight row">
      <div className="col-md-12">
        <div className="ibox">
          <form onSubmit={(e) => handleSubmit(e)}>
            <div className="ibox-content">
              <div className="form-group">
                <label>
                  <h4>Page Type:</h4>
                </label>
                <input
                  value={state.type}
                  type="text"
                  placeholder="Type must be one of [AGREEMENT, PRIVACY POLICY, TERMS AND SERVICES, LEGAL POLICY, PROMO CODE POLICY]"
                  className="form-control"
                  onChange={(e) =>
                    setState({
                      ...state,
                      type: String(e.target.value).toUpperCase(),
                    })
                  }
                />
              </div>
              <div className="form-group">
                <label>
                  <h4>Description:</h4>
                </label>
                <div
                  style={{
                    border: "1px solid rgba(0,0,0,.2)",
                    paddingBottom: "20px",
                    background: "white",
                  }}
                >
                  <ReactQuill
                    theme="snow"
                    onChange={(e) => onEditorStateChange(e)}
                    placeholder={`Write your content`}
                  />
                </div>
              </div>
              <div className="form-group text-end">
                <button
                  type="button"
                  className="btn btn-white btn-sm"
                  onClick={() => window.history.back()}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary-button btn-sm ms-2"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
